import React from 'react';
import './GoatBadge.scss';

const GoatBadge = ({ size = 'small' }) => (
    <span className={`goat-badge goat-badge-${size}`}>
        GOAT
    </span>
);

export default GoatBadge;
